import React, { useContext } from "react";
import PluginBridge from "../index";
import { anyHookTrue } from "@markedesk/plugin-sdk/ui";
import { WhatsAppsContext } from "../../../context/WhatsApp/WhatsAppsContext";

/**
 * Slot ao redor do botão "Novo Ticket".
 *
 * Decide esconder o botão nativo consultando o hook de UI
 * "new-ticket-button:hide-native" (registrado por plugins via frontendScript).
 * O hook recebe o contexto { connections } e cada plugin decide — ex: o
 * NotificameHub esconde o nativo só se houver conexão do canal dele.
 *
 * Plugins adicionam botões declarando actions com slot "new-ticket-button".
 *
 * Props:
 *   companyId — id da empresa (rota do plugin)
 *   children  — botão "Novo Ticket" nativo
 *   onPluginMessage — handler de postMessage do painel do plugin
 */
export default function NewTicketButtonSlot({ companyId, children, onPluginMessage }) {
  const { whatsApps } = useContext(WhatsAppsContext);

  const connections = (whatsApps || []).map((w) => ({
    id: w.id,
    name: w.name,
    channel: w.channel,
    status: w.status
  }));

  // Esconde o nativo E mostra o botão do plugin somente quando há conexão do
  // canal (mesma condição). Sem conexão do plugin → botão nativo normal,
  // evitando o "plugin sem rota configurada".
  const pluginActive = anyHookTrue("new-ticket-button:hide-native", { connections });

  return (
    <span style={{ display: "inline-flex", alignItems: "center" }}>
      {!pluginActive && children}
      {pluginActive && (
        <PluginBridge
          slot="new-ticket-button"
          as="text-buttons"
          context={{ companyId }}
          onPluginMessage={onPluginMessage}
        />
      )}
    </span>
  );
}
